import React from 'react'
import MailLogRow from "./MailLogRow";
import Api from '../../../services/Api'
import { useState, useEffect } from 'react';
import LoadingIcon from '../../formFields/LoadingIcon';


const MailsHistory = ({siteId, powerAppId, powerAppSolutionId, powerAppEnvironmentId}) => {

    const [history, setHistory] = useState([]);
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        getHistory();
    }, [])
    

    const getHistory = () => {
        setIsLoading(true);

        let query = '';
        if (siteId) {
            query = `siteId=${siteId}`
        }
        else if (powerAppId) {
            query = `powerAppId=${powerAppId}`
        }
        else if (powerAppSolutionId) {
            query = `powerAppSolutionId=${powerAppSolutionId}`
        }
        else if (powerAppEnvironmentId) {
            query = `powerAppEnvironmentId=${powerAppEnvironmentId}`
        }

        if (query) {
            Api.get(`/siteHistory?${query}&getMailsHistory=true`)
            .then(res => res.data)
            .then(data => {
                setHistory(data);
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
            });
        }
    }

    const list = history.map((x, index) => {
        return  <MailLogRow 
                    key={index}
                    even={index % 2 === 0}
                    date={x.date}
                    status={x.status}
                    scenario={x.scenario}
                    subject={x.subject}
                    to={x.to}
                    cc={x.cc}
                />
    })

    return(
        <div style={{padding: '10px 0', minWidth: 500}}>
            {
                isLoading 
                ? <LoadingIcon /> 
                : list
            }
        </div>
    );
}
export default MailsHistory


// WEBPACK FOOTER //
// ./src/components/Administration/SiteDetails/MailsHistory.js